module.exports = __webpack_public_path__ + "media/images/ecalls/06_fausto_gradient_bg-19b9753d15c1d79cd0841b21dd5462ac.png";